import { useState, useEffect, useCallback } from 'react';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { formatMoeda } from '../../utils/fmt';
import { precoVitrine } from '../../utils/precoModelo';
import { useAuth } from '../../contexts/AuthContext';
import * as modelosApi from '../../api/modelos';
import * as estoqueApi from '../../api/estoque';
import * as clientesApi from '../../api/clientes';
import * as tamanhosApi from '../../api/tamanhos';
import * as empresasApi from '../../api/empresas';

const PLACEHOLDER = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="160" viewBox="0 0 200 160"%3E%3Crect width="200" height="160" fill="%23e8eaf0"/%3E%3Ctext x="100" y="85" text-anchor="middle" fill="%23999" font-size="13" font-family="sans-serif"%3ESem foto%3C/text%3E%3C/svg%3E';

function ModalDetalhe({ modelo, clienteNome, empresaNome, mostrarEmpresa, estoque, tamanhoNome, onClose }) {
  const estoqueModelo = estoque.filter(e => e.id_modelo_uniforme === modelo.id_modelo_uniforme);
  const totalDisp = estoqueModelo.reduce((s, e) => s + e.quantidade_disponivel, 0);
  const totalRes  = estoqueModelo.reduce((s, e) => s + e.quantidade_reservada_fabricacao, 0);

  return (
    <div className="modal show d-block" style={{ background: 'rgba(0,0,0,.45)' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div>
              <h5 className="modal-title mb-0">{modelo.nome}</h5>
              <small style={{ color: 'rgba(255,255,255,.6)' }}>
                {clienteNome}{mostrarEmpresa && <> · {empresaNome(modelo.id_empresa_operadora)}</>}
              </small>
            </div>
            <button className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            <div className="row g-3">
              <div className="col-md-5">
                <div style={{ position: 'relative', paddingTop: '75%', overflow: 'hidden', borderRadius: 4 }}>
                  <img
                    src={modelo.fotos?.[0]?.url || PLACEHOLDER}
                    alt={modelo.nome}
                    style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
              </div>
              <div className="col-md-7">
                <div className="mb-3">
                  <div className="text-muted" style={{ fontSize: 12, marginBottom: 2 }}>
                    {modelo.tipo_preco === 'por_tamanho' ? 'Preço por tamanho' : 'Preço unitário'}
                  </div>
                  {modelo.tipo_preco === 'por_tamanho' ? (
                    <div className="d-flex flex-wrap gap-2 mt-1">
                      {(modelo.tamanhos || []).map(t => (
                        <span key={t.id_tamanho_uniforme} className="badge bg-light text-dark border" style={{ fontSize: 12 }}>
                          {tamanhoNome(t.id_tamanho_uniforme)}: {formatMoeda(t.preco_unitario)}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <div className="fw-bold" style={{ color: 'var(--cjc-primary)', fontSize: 24 }}>
                      {formatMoeda(modelo.preco_unitario)}
                    </div>
                  )}
                </div>

                {modelo.descricao && (
                  <p className="text-muted" style={{ fontSize: 13 }}>{modelo.descricao}</p>
                )}

                <div className="mb-3">
                  <div className="text-muted mb-1" style={{ fontSize: 12 }}>Tamanhos disponíveis</div>
                  <div className="d-flex flex-wrap gap-1">
                    {(modelo.tamanhos || []).map(t => (
                      <span key={t.id_tamanho_uniforme} className="badge bg-light text-dark border" style={{ fontSize: 11 }}>
                        {tamanhoNome(t.id_tamanho_uniforme)}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Estoque por tamanho */}
                {estoqueModelo.length > 0 && (
                  <div>
                    <div className="text-muted mb-2" style={{ fontSize: 12 }}>Posição de estoque</div>
                    <div className="table-responsive">
                      <table className="table table-sm mb-0" style={{ fontSize: 12 }}>
                        <thead>
                          <tr>
                            <th>Tam.</th>
                            <th>Disponível</th>
                            <th>Em fabricação</th>
                          </tr>
                        </thead>
                        <tbody>
                          {estoqueModelo.map(e => (
                            <tr key={e.id_tamanho_uniforme}>
                              <td><span className="badge bg-secondary">{tamanhoNome(e.id_tamanho_uniforme)}</span></td>
                              <td>
                                <span className={`fw-semibold ${e.quantidade_disponivel > 0 ? 'text-success' : 'text-muted'}`}>
                                  {e.quantidade_disponivel}
                                </span>
                              </td>
                              <td>
                                {e.quantidade_reservada_fabricacao > 0
                                  ? <span className="fw-semibold text-warning">{e.quantidade_reservada_fabricacao}</span>
                                  : <span className="text-muted">—</span>}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr style={{ borderTop: '2px solid #dee2e6' }}>
                            <td className="fw-bold">Total</td>
                            <td className="fw-bold text-success">{totalDisp}</td>
                            <td className={`fw-bold ${totalRes > 0 ? 'text-warning' : 'text-muted'}`}>
                              {totalRes || '—'}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}

                {estoqueModelo.length === 0 && (
                  <div className="alert alert-warning py-2" style={{ fontSize: 13 }}>
                    Nenhum estoque registrado para este modelo.
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary btn-sm" onClick={onClose}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function CatalogoOperador() {
  const { user } = useAuth();
  const souAdmin = user?.perfil === 'admin';
  const emGlobal = souAdmin && !user?.empresa_ativa_id;

  const [modelos,  setModelos]  = useState([]);
  const [estoque,  setEstoque]  = useState([]);
  const [clientes, setClientes] = useState([]);
  const [tamanhos, setTamanhos] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [idEmpresaFiltro, setIdEmpresaFiltro] = useState('');
  const [loading,  setLoading]  = useState(true);
  const [busca,         setBusca]         = useState('');
  const [filtroCliente, setFiltroCliente] = useState('');
  const [modal, setModal] = useState(null);
  const [erroCarregar, setErroCarregar] = useState('');

  const carregar = useCallback(() => {
    setLoading(true);
    setErroCarregar('');
    Promise.all([modelosApi.listar(), estoqueApi.listar(), clientesApi.listar(), tamanhosApi.listar()])
      .then(([m, e, c, tam]) => { setModelos(m.data); setEstoque(e.data); setClientes(c.data); setTamanhos(tam.data); })
      .catch(() => setErroCarregar('Erro ao carregar dados. Recarregue a página.'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  useEffect(() => {
    if (souAdmin) empresasApi.listEmpresas().then(r => setEmpresas(r.data)).catch(() => {});
  }, [souAdmin]);

  const clienteNome = id => id ? (clientes.find(c => c.id_cliente_final === id)?.nome || '—') : 'Geral da empresa';
  const tamanhoNome = id => tamanhos.find(t => t.id_tamanho_uniforme === id)?.nome || id;
  const empresaNome = id => empresas.find(e => e.id_empresa_operadora === id)?.nome || '—';
  // No Modo Global sem uma empresa escolhida, "Geral da empresa" e o mesmo cliente
  // podem estar misturando modelos de empresas diferentes — mostra a empresa em cada
  // card pra desambiguar (só necessário nesse caso; com 1 empresa escolhida, é óbvio).
  const mostrarEmpresaNoCard = emGlobal && !idEmpresaFiltro;

  const filtrados = modelos.filter(m => {
    if (emGlobal && idEmpresaFiltro && m.id_empresa_operadora !== idEmpresaFiltro) return false;
    const q = busca.toLowerCase();
    const matchBusca = m.nome.toLowerCase().includes(q) || clienteNome(m.id_cliente_final).toLowerCase().includes(q);
    const matchCliente = filtroCliente
      ? (filtroCliente === '_geral' ? !m.id_cliente_final : m.id_cliente_final === filtroCliente)
      : true;
    return matchBusca && matchCliente;
  });

  // Agrupa por cliente — modelos "geral" (sem cliente) formam seu próprio grupo.
  const grupoGeral = filtrados.filter(m => !m.id_cliente_final);
  const grupos = [
    ...(grupoGeral.length > 0 ? [{ id: '_geral', nome: 'Geral da empresa', modelos: grupoGeral }] : []),
    ...clientes
      .filter(c => filtrados.some(m => m.id_cliente_final === c.id_cliente_final))
      .map(c => ({ id: c.id_cliente_final, nome: c.nome, modelos: filtrados.filter(m => m.id_cliente_final === c.id_cliente_final) })),
  ];

  const estoqueDisponivel = id =>
    estoque.filter(e => e.id_modelo_uniforme === id).reduce((s, e) => s + e.quantidade_disponivel, 0);

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <PageHeader
        titulo="Catálogo"
        subtitulo={`${filtrados.length} modelo(s) em ${grupos.length} grupo(s)`}
      />

      {erroCarregar && <div className="alert alert-danger py-2">{erroCarregar}</div>}

      <div className="d-flex gap-2 mb-4 flex-wrap">
        <input
          className="form-control"
          style={{ maxWidth: 300 }}
          placeholder="Buscar por modelo ou cliente..."
          value={busca}
          onChange={e => setBusca(e.target.value)}
        />
        <select
          className="form-select"
          style={{ maxWidth: 260 }}
          value={filtroCliente}
          onChange={e => setFiltroCliente(e.target.value)}
        >
          <option value="">Todos os clientes</option>
          <option value="_geral">Geral da empresa</option>
          {clientes.map(c => (
            <option key={c.id_cliente_final} value={c.id_cliente_final}>{c.nome}</option>
          ))}
        </select>
        {emGlobal && (
          <select className="form-select" style={{ maxWidth: 220 }}
            value={idEmpresaFiltro} onChange={e => setIdEmpresaFiltro(e.target.value)}>
            <option value="">Todas as empresas</option>
            {empresas.map(e => <option key={e.id_empresa_operadora} value={e.id_empresa_operadora}>{e.nome}</option>)}
          </select>
        )}
        {(busca || filtroCliente || idEmpresaFiltro) && (
          <button className="btn btn-outline-secondary btn-sm"
            onClick={() => { setBusca(''); setFiltroCliente(''); setIdEmpresaFiltro(''); }}>
            Limpar filtros
          </button>
        )}
      </div>

      {filtrados.length === 0 && (
        <div className="text-center text-muted py-5">Nenhum modelo encontrado.</div>
      )}

      {grupos.map(({ id: idGrupo, nome: nomeGrupo, modelos: modelosGrupo }) => (
        <div key={idGrupo} className="mb-5">
          <div className="d-flex align-items-center gap-3 mb-3">
            <div
              style={{
                width: 4, height: 28, borderRadius: 2,
                background: 'var(--cjc-accent)', flexShrink: 0,
              }}
            />
            <div>
              <div className="fw-bold" style={{ color: 'var(--cjc-primary)', fontSize: 15 }}>
                {nomeGrupo}
              </div>
              <div className="text-muted" style={{ fontSize: 12 }}>
                {modelosGrupo.length} modelo(s)
              </div>
            </div>
          </div>

          <div className="row g-3">
            {modelosGrupo.map(m => {
              const disp = estoqueDisponivel(m.id_modelo_uniforme);
              return (
                <div key={m.id_modelo_uniforme} className="col-sm-6 col-lg-4 col-xl-3">
                  <div
                    className="card h-100"
                    style={{ cursor: 'pointer', transition: 'transform .15s, box-shadow .15s' }}
                    onClick={() => setModal(m)}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = 'var(--cjc-shadow-2)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
                  >
                    <div style={{ position: 'relative', paddingTop: '75%', overflow: 'hidden', borderRadius: '2px 2px 0 0' }}>
                      <img
                        src={m.fotos?.[0]?.url || PLACEHOLDER}
                        alt={m.nome}
                        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </div>
                    <div className="card-body d-flex flex-column" style={{ padding: '12px 14px' }}>
                      <div className="fw-semibold mb-1" style={{ color: 'var(--cjc-primary)', fontSize: 13, lineHeight: 1.3 }}>
                        {m.nome}
                      </div>
                      {mostrarEmpresaNoCard && (
                        <div className="text-muted mb-1" style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.04em' }}>
                          {empresaNome(m.id_empresa_operadora)}
                        </div>
                      )}
                      {m.descricao && (
                        <p className="text-muted mb-2" style={{
                          fontSize: 11, flexGrow: 1,
                          overflow: 'hidden', display: '-webkit-box',
                          WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                        }}>
                          {m.descricao}
                        </p>
                      )}
                      <div className="d-flex justify-content-between align-items-center mt-auto mb-2">
                        <span className="fw-bold" style={{ color: 'var(--cjc-primary)', fontSize: 15 }}>
                          {precoVitrine(m).aPartirDe && <span className="text-muted" style={{ fontSize: 10, fontWeight: 400 }}>A partir de </span>}
                          {formatMoeda(precoVitrine(m).valor)}
                        </span>
                        <span
                          className={`badge ${disp > 0 ? 'bg-success' : 'bg-warning text-dark'}`}
                          style={{ fontSize: 10 }}
                        >
                          {disp > 0 ? `${disp} em estoque` : 'Sob demanda'}
                        </span>
                      </div>
                      <div className="d-flex flex-wrap gap-1">
                        {(m.tamanhos || []).slice(0, 6).map(t => (
                          <span key={t.id_tamanho_uniforme} className="badge bg-light text-dark border" style={{ fontSize: 10 }}>
                            {tamanhoNome(t.id_tamanho_uniforme)}
                          </span>
                        ))}
                        {(m.tamanhos || []).length > 6 && (
                          <span className="badge bg-light text-muted border" style={{ fontSize: 10 }}>
                            +{m.tamanhos.length - 6}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {modal && (
        <ModalDetalhe
          modelo={modal}
          clienteNome={clienteNome(modal.id_cliente_final)}
          empresaNome={empresaNome}
          mostrarEmpresa={emGlobal}
          estoque={estoque}
          tamanhoNome={tamanhoNome}
          onClose={() => setModal(null)}
        />
      )}
    </div>
  );
}
